/**
 * RESPONSIBILITY: draw an event's photographs.
 *
 * A grid rather than a carousel. A carousel hides all but one picture behind a control
 * the visitor has to work out, and it hides them from the browser's find-in-page and
 * from printing; a grid is every photograph, at once, for less code.
 */
import { idOf } from '@framework/core';
import { THEME } from '@app/sections';
import { Band } from './Band';
import { Picture } from '../../commons/Picture';
import type { BandProps } from './kind';

export function Gallery({ s }: BandProps) {
  const pics = s.pictures ?? [];
  if (!pics.length) return null;

  return (
    <Band theme={THEME.Gallery} heading={s.heading}>
      <ul className="ev-gallery">
        {pics.map((p) => (
          <li key={idOf(p)}>
            <Picture value={p.image} alt={p.caption} className="ev-shot" />
            {p.caption ? <span className="ev-caption">{p.caption}</span> : null}
          </li>
        ))}
      </ul>
    </Band>
  );
}
